module.exports = __webpack_public_path__ + "img/mobFlag.f33b27fc.svg";